import { conversionFechaJson, conversionNumberJson, conversionStringJson, convertirFechaFirebase } from "./utiles_objetos";

export class CostoPago {
    constructor({
        documentoId = "",
        fecha = new Date(),
        descripcion = "",
        concepto = "",
        formaPago = "",
        referencia = "",
        proveedor = "",
        valor = 0,
        indexPago = "",
        ultimaModificacion = 0,
        metaPagos = [],
        
        //nuevas
        linkFactura = "", //factura de pago
        linkComprobante = "", //comprobante de pago

    } = {}){
        this.documentoId = documentoId;
        this.fecha = fecha;
        this.descripcion = descripcion;
        this.concepto = concepto;
        this.formaPago = formaPago;
        this.referencia = referencia;
        this.proveedor = proveedor;
        this.valor = valor;
        this.indexPago = indexPago;
        this.ultimaModificacion = ultimaModificacion;
        this.metaPagos = metaPagos;

        //nuevas
        this.linkFactura = linkFactura;
        this.linkComprobante = linkComprobante;
    }

    static fromJson(json){
        const fechaLocal = convertirFechaFirebase(json['fecha']);
        console.log("revisando jsonn",json);

        return new CostoPago({
            documentoId: json['documentoId'] || '',
            fecha: fechaLocal,
            descripcion:  json['descripcion'] || '',
            concepto: json['concepto'] || '',
            formaPago: json['formaPago'] || '',
            referencia: json['referencia'] || '',
            proveedor:  json['proveedor'] || '',
            valor: json['valor'] || 0,
            indexPago: json['indexPago'] || '',
            ultimaModificacion: json['ultimaModificacion'] || 0,
            metaPagos: (json['metaPagos'] || []).map(metaPagoData => MetaMarketing.fromJson(metaPagoData)),

            //nuevas
            linkFactura: json['linkFactura'] || '',
            linkComprobante: json['linkComprobante'] || '',
        });
    }

    toJson(){

    }

    toMap(){
        return{
            'fecha' : conversionFechaJson(this.fecha, new Date()),
            'descripcion' :conversionStringJson(this.descripcion, ''),
            'concepto' : conversionStringJson(this.concepto, ''),
            'formaPago' :conversionStringJson(this.formaPago, ''),
            'referencia' :conversionStringJson(this.referencia, ''),
            'proveedor' :conversionStringJson(this.proveedor, ''),
            'valor' :conversionNumberJson(this.valor, 0),
            'ultimaModificacion' : conversionNumberJson(this.ultimaModificacion, 0),
            "indexPago" : conversionStringJson(this.indexPago, ''),

            //nuevas
            'linkFactura' :conversionStringJson(this.linkFactura, ''),
            'linkComprobante' :conversionStringJson(this.linkComprobante, ''),

        }
    }

    updateFromJson(updateData){
        if (!updateData || typeof updateData !== 'object') {
            console.warn('updateData debe ser un objeto válido');
            return;
        }

        Object.keys(updateData).forEach(field => {
            const value = updateData[field];
            console.log(`🔧 Procesando campo: ${field}, tipo: ${typeof value}`);
        
            switch(field) {

             case 'fecha':
                this.fecha = conversionFechaJson(value, this.fecha);
                break;

            case 'descripcion':
                this.descripcion = conversionStringJson(value, this.descripcion);
                break;

            case 'concepto':
                this.concepto = conversionStringJson(value, this.concepto);
                break;

            case 'formaPago':
                this.formaPago = conversionStringJson(value, this.formaPago);
                break;

            case 'referencia':
                this.referencia = conversionStringJson(value, this.referencia);
                break;

            case 'proveedor':
                this.proveedor = conversionStringJson(value, this.proveedor);
                break;

            case 'valor':
                this.valor = conversionNumberJson(value, this.valor);
                break;

            case 'indexPago':
                this.indexPago = conversionStringJson(value, this.indexPago);
                break;
              
            default:
                console.warn(`Campo desconocido en update data de Solicitudes: ${field}`);
                break;
            }
        });
    }

    getFieldValue(fieldPath) {
        console.log(`🔍 Obteniendo valor para: ${fieldPath}`);
        
        if (fieldPath.includes('.')) {
            const [objectName, fieldName] = fieldPath.split('.');
            const value = this[objectName]?.[fieldName];
            console.log(`📦 Valor anidado ${objectName}.${fieldName}:`, value);
            return value;
        }
        
        const value = this[fieldPath];
        console.log(`📝 Valor directo ${fieldPath}:`, value);
        return value;
    }


}

export class MetaMarketing{
    constructor({
        fecha = new Date(),
        nombreCampana = "",
        valorCancelado = 0,
    } = {}){
        this.fecha = fecha;
        this.nombreCampana = nombreCampana;
        this.valorCancelado = valorCancelado;
    }

    static fromJson(json){
        const fechaLocal = convertirFechaFirebase(json['fecha']);

        return new MetaMarketing({
            fecha: fechaLocal,
            nombreCampana: json['nombreCampana'] || '',
            valorCancelado: json['valorCancelado'] || 0,
        });
    }

    toJson(){

    }

    toMap(){

    }
}